import React, { useRef, useEffect, useState } from 'react';
import { FaceLivenessDetectorCore } from '@aws-amplify/ui-react-liveness';
import { ThemeProvider } from '@aws-amplify/ui-react';
import * as displayTextUiFace from '../../utils/displayTextUiFace.js';
import { Sun, Glasses, ScanFace, CircleX, Camera } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import {ModalErroReact} from '../../modals/ModalErroReact.js';

import {buildLivenessError} from '../../utils/createTextError.js';

import { CreateFaceLivenessSessionCommand, GetFaceLivenessSessionResultsCommand } from "@aws-sdk/client-rekognition";

import {evaluateLivenessAndAccessories} from '../../utils/verifyLabels.js';
import { createRekognitionClient } from '../../credentials/awsClients.js';
import { createCredentialProvider } from '../../credentials/awsClients.js';

import './liveness.scss';
import { CountdownBar } from '../../components/CountdownBar.tsx';
import InternetStatus from '../../components/conexao.tsx';
import HeaderHora from '../../components/headerHora.tsx';
import { useInternetStatus } from '../../utils/useInternetStatus.ts';

// import TentativaStatus from '../../components/tentativas.tsx';
// import { BusinessHoursGate } from '../../utils/TentativaStatus.tsx';
// import SupportFloatingChat from '../../components/SupportFloatingChat.tsx';


const rek = createRekognitionClient();

export function LivenessQuickStartReact() {
  const [loading, setLoading] = useState(true);
  const [apiData, setApiData] = useState(null);
  const [show, setShow] = useState(false);
  const [permision, setPermision] = useState(false);
  const didFetch = useRef(false);

  const [isOpen, setIsOpen] = useState(false);
  const [modalError, setModalError] = useState(false);

  const [capturaIniciada, setCapturaIniciada] = useState(false);
  const livenessWrapRef = useRef(null);
  const [tentativas, setTentativas] = useState(1);

  const navigate = useNavigate();

  const { status } = useInternetStatus({
    pingUrl: "/ping",
    intervalMs: 20000,
    unstableLatencyMs: 900,
    unstableJitterMs: 350,
    failToOffline: 2,
  });

  useEffect(() => {
    const el = livenessWrapRef.current;
    console.log("LivenessWrapRef:", el);
    if (!el) return;

    const onClick = (ev) => {
      console.log("Click event:", ev);
      const target = ev.target;
      const btn = target?.closest("button");
      if (!btn) return;

      const txt = (btn.innerText || btn.textContent || "").trim().toLowerCase();

      if (txt === "começar" || txt.includes("começar") || txt.includes("comecar")) {
        setCapturaIniciada(true);
      }
    };

    el.addEventListener("click", onClick, true); // true = captura, pega mesmo se o SDK parar propagação
    return () => el.removeEventListener("click", onClick, true);
  }, [permision, loading, livenessWrapRef, modalError, isOpen, show, tentativas]);
  
  useEffect(() => {
    let infoLink = JSON.parse(sessionStorage.getItem('dadosLinkAtual'));
    const tipoDoc = sessionStorage.getItem('tipoDoc');

    if(infoLink.outLiveness === 'S'){
      if (tipoDoc === 'naoHabilitado' && infoLink.outValidacaoPix === 'S') {
        navigate("/validaid");
      }
      else {
        navigate("/sucesso");
      }

      return
    }

    if (didFetch.current) return;
    didFetch.current = true;

    (async () => {
      await geraSessionId();
    })();
  }, [navigate]);

  useEffect(() => {
    if (apiData) {
      setLoading(false);
    }
  }, [apiData]);

  const geraSessionId = async () => {
    try {
      const command = new CreateFaceLivenessSessionCommand({
        Settings: {
          AuditImagesLimit: 4,
          ChallengePreferences: [
            {
              Type: "FaceMovementChallenge",
              Versions: { Minimum: "1.0.0", Maximum: "999.999.999" },
            }
          ],
          OutputConfig: {
            S3Bucket: "sociiz-identity-verification",
            S3KeyPrefix: `${JSON.parse(sessionStorage.getItem('dadosLinkAtual')).outDocumento}/liveness`
          }
        }
      });
      const liveRes = await rek.send(command);
      setApiData(liveRes);
      setShow(true);
    } catch (err) {
      console.error('Erro ao criar sessão:', err);
    }
  }
  
  const reiniciar = async () => {
    setShow(false);
    await geraSessionId();
    setTimeout(() => setShow(true), 100);
  };


  const handleAnalysisComplete = async () => {
    const resultLiveness = await rek.send(
      new GetFaceLivenessSessionResultsCommand({ SessionId: apiData.SessionId })
    );

    const resp = await evaluateLivenessAndAccessories(apiData.SessionId);

    if(resp.passed === true){
      if(resultLiveness.ReferenceImage.S3Object){
        try{
          const res = await fetch(`${process.env.REACT_APP_URL_API}/conform/send-file`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('sessionTokenBearer')}`,
                'fileName': resultLiveness.ReferenceImage.S3Object.Name,
                'token': sessionStorage.getItem('sessionToken'),
                'tipo': 'LIVENESS'
              }
          });
          
          const data = await res.json();

          if(data.erros === false){
            const tipoDoc = sessionStorage.getItem('tipoDoc');
            const outValidacaoPix = JSON.parse(sessionStorage.getItem('dadosLinkAtual')).outValidacaoPix;

            const raw = sessionStorage.getItem('dadosLinkAtual');
            const obj = raw ? JSON.parse(raw) : {};
            obj.outLiveness = "S";
            sessionStorage.setItem('dadosLinkAtual', JSON.stringify(obj));

            if (tipoDoc === 'naoHabilitado' && outValidacaoPix === 'S') {
              navigate("/validaid");
            }
            else {
              navigate("/sucesso");
            }
          }
          else{
            setIsOpen(true);
          }
        }
        catch (err){
          setIsOpen(true);
        }
      }
    }
    else{
      setTentativas(prev => prev + 1);
      setCapturaIniciada(false);
      const error = buildLivenessError(resp);
      setModalError(error);
      setIsOpen(true);
    }
  };

  return (
    <ThemeProvider>
      {loading ? (
        <div className='content'>
          <div className='content-loading'>
            <span className="loader"></span>
            <p className='text-load'>Configurando a câmera.</p>
            <p className='subtext-load'>Iniciando a câmera para seguir com sua verificação. Isso leva apenas alguns segundos. Por favor, não feche a tela.</p>
          </div>
        </div>
      ) : (
        show ? (
          <>
            {!permision ? (
              <div className="viewer-page">
                <div className="viewer-content">
                  <div className='content'>
                    <div className='content-liveness'>
                      {sessionStorage.getItem('ambienteOrigem') !== 'totemalprev' ?
                          <div className='header'>Permitir uso da câmera <HeaderHora/></div>
                        : null
                      }
                      <div className='regras-face'>
                        {sessionStorage.getItem('ambienteOrigem') !== 'totemalprev' ?
                            <span className='text-1'>Para continuar, precisamos acessar a câmera do seu celular. Vamos tirar uma foto do seu rosto para confirmar sua identidade.</span>
                          : null
                        }
                        <span className='text-2'>Siga as orientações abaixo:</span>
                        {sessionStorage.getItem('ambienteOrigem') !== 'totemalprev' ?
                            <span className='text-3'><Sun className='icon-primary-color'/> Fique em um local bem iluminado</span>
                          :
                          <span className='text-3'><Camera className='icon-primary-color'/> Fique de frente para a câmera.</span>
                        }
                        <span className='text-3'><Glasses className='icon-primary-color'/> Deixe o rosto bem visível e retire óculos, boné ou máscara</span>
                        <span className='text-3'><ScanFace className='icon-primary-color'/> Permaneça parado(a) até a foto ser tirada</span>
                        {/* <button onClick={() => setPermision(true)}>CONTINUAR</button> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="viewer-footer">
                  <button onClick={() => setPermision(true)}>CONTINUAR</button>
                </div>
              </div>

            ) : (
              <div className='content'>
                <div className='content-liveness'>
                  {sessionStorage.getItem('ambienteOrigem') !== 'alprev' ? (
                    <div className='header'>Confirme sua identidade <HeaderHora/></div>
                  ) : null}

                  <div className='status-face'>
                    <CountdownBar/>
                    {/* <BusinessHoursGate fallback={null}>
                      <TentativaStatus atual={tentativas} total={3} />
                      <SupportFloatingChat
                        visible={tentativas >= 3}
                        onClick={() => {
                          window.open('https://webchat-sociiz-suporte-liveness.netlify.app/', '_blank');
                        }}
                      />
                    </BusinessHoursGate> */}
                    <InternetStatus />
                  </div>

                  {!capturaIniciada && (
                    <>
                      {status === "offline" ? (
                        <div className="info-face">
                          {/* SVG vermelho */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <rect width="20" height="20" fill="white" fillOpacity="0.01" />
                            <path d="M9.99998 1.25017C8.84892 1.24303 7.7079 1.46448 6.64308 1.90168C5.57826 2.33889 4.61083 2.98313 3.79689 3.79707C2.98295 4.61101 2.3387 5.57844 1.9015 6.64326C1.4643 7.70808 1.24285 8.84911 1.24998 10.0002C1.24285 11.1512 1.4643 12.2923 1.9015 13.3571C2.3387 14.4219 2.98295 15.3893 3.79689 16.2033C4.61083 17.0172 5.57826 17.6614 6.64308 18.0986C7.7079 18.5359 8.84892 18.7573 9.99998 18.7502C11.151 18.7573 12.2921 18.5359 13.3569 18.0986C14.4217 17.6614 15.3891 17.0172 16.2031 16.2033C17.017 15.3893 17.6613 14.4219 18.0985 13.3571C18.5357 12.2923 18.7571 11.1512 18.75 10.0002C18.7571 8.84911 18.5357 7.70808 18.0985 6.64326C17.6613 5.57844 17.017 4.61101 16.2031 3.79707C15.3891 2.98313 14.4217 2.33889 13.3569 1.90168C12.2921 1.46448 11.151 1.24303 9.99998 1.25017ZM13.403 14.3752L5.62498 6.59748L6.5973 5.62517L14.375 13.4032L13.403 14.3752Z" fill="#DA1E28"/>
                          </svg>
                          Sem conexão com a internet. Verifique sua rede e tente novamente.
                        </div>
                      ) : status === "unstable" ? (
                        <div className="info-face">
                          {/* SVG amarelo */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <rect width="20" height="20" fill="white" fillOpacity="0.01" style={{ mixBlendMode: "multiply" }} />
                            <path d="M10 1.25C5.1875 1.25 1.25 5.1875 1.25 10C1.25 14.8125 5.1875 18.75 10 18.75C14.8125 18.75 18.75 14.8125 18.75 10C18.75 5.1875 14.8125 1.25 10 1.25ZM9.3125 5H10.6875V11.875H9.3125V5V5ZM10 15.625C9.5 15.625 9.0625 15.1875 9.0625 14.6875C9.0625 14.1875 9.5 13.75 10 13.75C10.5 13.75 10.9375 14.1875 10.9375 14.6875C10.9375 15.1875 10.5 15.625 10 15.625Z" fill="#F1C21B"/>
                          </svg>
                          Internet instável. Isso pode causar erros na verificação.
                        </div>
                      ) : (
                        <div className="info-face">
                          {/* SVG azul */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <rect width="20" height="20" fill="white" fillOpacity="0.01"/>
                            <path d="M10 1.25C8.26942 1.25 6.57769 1.76318 5.13876 2.72464C3.69983 3.6861 2.57832 5.05267 1.91606 6.65152C1.25379 8.25037 1.08051 10.0097 1.41813 11.707C1.75575 13.4044 2.58911 14.9635 3.81282 16.1872C5.03653 17.4109 6.59563 18.2442 8.29296 18.5819C9.9903 18.9195 11.7496 18.7462 13.3485 18.0839C14.9473 17.4217 16.3139 16.3002 17.2754 14.8612C18.2368 13.4223 18.75 11.7306 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM10 5C10.1854 5 10.3667 5.05498 10.5209 5.158C10.675 5.26101 10.7952 5.40743 10.8661 5.57873C10.9371 5.75004 10.9557 5.93854 10.9195 6.1204C10.8833 6.30225 10.794 6.4693 10.6629 6.60041C10.5318 6.73152 10.3648 6.82081 10.1829 6.85699C10.001 6.89316 9.81254 6.87459 9.64124 6.80364C9.46993 6.73268 9.32351 6.61252 9.2205 6.45835C9.11749 6.30418 9.0625 6.12292 9.0625 5.9375C9.0625 5.68886 9.16128 5.4504 9.33709 5.27459C9.51291 5.09877 9.75136 5 10 5ZM12.5 15.0781H7.5V13.6719H9.29688V10.0781H8.125V8.67188H10.7031V13.6719H12.5V15.0781Z" fill="#0F62FE"/>
                          </svg>
                          Encaixe o rosto no círculo e clique em começar
                        </div>
                      )}
                    </>
                  )}
 
                  <div ref={livenessWrapRef}>    
                  <FaceLivenessDetectorCore
                    sessionId={apiData.SessionId}
                    region="us-east-1"
                    onAnalysisComplete={handleAnalysisComplete}
                    onError={(error) => {
                      console.error("Erro no Liveness Detector:", error);
                      reiniciar();
                    }}
                    displayText={displayTextUiFace.defaultLivenessDisplayText}
                    components={{
                      PhotosensitiveWarning: () => null,
                      ErrorView: () => null
                    }}
                    config={{
                      credentialProvider: createCredentialProvider(),
                      binaryPath: 'https://cdn.liveness.rekognition.amazonaws.com/face-detection/tensorflow/tfjs-backend-wasm/4.11.0/',
                      faceModelUrl: 'https://cdn.liveness.rekognition.amazonaws.com/face-detection/tensorflow-models/blazeface/1.0.2/model/model.json',
                    }}
                  />
                  </div>
                </div>
              </div>
            )}
          </>
        ) : 
        <div className='content'>
          <div className='content-loading'>
            <span className="loader"></span>
            <p className='text-load'>Configurando a câmera.</p>
            <p className='subtext-load'>Iniciando a câmera para seguir com sua verificação. Isso leva apenas alguns segundos. Por favor, não feche a tela.</p>
          </div>
        </div>
      )}

      <ModalErroReact
        isOpen={isOpen}
        onRequestClose={() => {
          setIsOpen(false);
          reiniciar();
        }}
      >
        <div className="icon-result">
          <CircleX color="#F71A1A" strokeWidth={2} size={120} />
        </div>

        <div className="text-4">
          {modalError?.title ?? "Não conseguimos confirmar sua presença."}
        </div>

        <div className="text-5">
          {modalError?.message ??
            "A imagem capturada não foi clara o suficiente para validar que você está presente. Verifique a iluminação, centralize o rosto e tente novamente."}
        </div>

        <div className="buttons-group">
          <button
            onClick={() => {
              setIsOpen(false);
              reiniciar();
            }}
          >
            TENTAR NOVAMENTE
          </button>
        </div>
      </ModalErroReact>

    </ThemeProvider>
  );
  
}